/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ExportFormatEnumDto {
  CSV = 'Csv',
}
